import React from "react";
import Modal from "react-bootstrap/Modal";
import { isDefined } from "../../utils/utils";


const AlertPopup = ({
  showAlertPopup,
  onSuccess,
  onCancel,
  onExit,
  onDiscard,
  popupTitle,
  popupContent,
  customHtmlPopupContent,
  cancelButtonText,
  confirmButtonText,
  exitButtonText
}) => {

  // Funzione che gestisce la chiusura del popup
  const handleClose = () => {
    if (onDiscard)
      onDiscard(false);
  }

  // Funzione che gestisce il click sul tasto Conferma del popup
  const handleConfirm = () => {
    if (onSuccess)
      onSuccess();
    handleClose();
  }


  return (
    <Modal show={showAlertPopup} onHide={handleClose} animation={false} size="lg" centered>
      {
        isDefined(popupTitle) &&
        <Modal.Header closeButton>
          <Modal.Title>{popupTitle}</Modal.Title>
        </Modal.Header>
      }
      <Modal.Body>
        {

          customHtmlPopupContent ?
            <div className="mx-3" dangerouslySetInnerHTML={{ __html: customHtmlPopupContent }}></div>
            :
            <div>{popupContent}</div>
        }

        <div className="d-flex justify-content-between w-100 mx-0 mt-5">
          {
            exitButtonText && onExit &&
            <div>
              <button
                type="button"
                className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                onClick={onExit}>
                {exitButtonText}
              </button>
            </div>
          }

          <div>
            {cancelButtonText &&
              <button
                type="button"
                className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                onClick={onCancel ? () => onCancel() : handleClose}>
                {cancelButtonText}
              </button>
            }
          </div>

          <div>
            <button
              type="button"
              className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
              onClick={handleConfirm}>
              {confirmButtonText}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AlertPopup;